import { createFileRoute } from '@tanstack/react-router';

import { AgeStep } from '@/features/onboarding/components/steps/personal/ageStep';

export const Route = createFileRoute('/_protected/onboarding/_steps/age')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AgeStep />;
}
